import axios from "axios";
import authHeader from "./auth-header";
import store from "@/store";
import router from "@/router";

const API_URL = process.env.VUE_APP_API_URL;

class AuthService {
  refreshPromise = null;

  // Convert AuthService to a singleton
  constructor() {
    if (AuthService._instance) {
      return AuthService._instance;
    }
    AuthService._instance = this;
  }

  async login(user) {
    const response = await axios.post(
      "https://api.varsanpr.com/api/auth/login",
      {
        email: user.username,
        password: user.password,
      },
      {
        headers: {
          "x-vars-version": 2,
        },
      }
    );
    if (response.data.token) {
      let user = response.data;
      localStorage.setItem(
        "user",
        JSON.stringify({
          permissions: user.permissions,
          ...user.user,
          // clients: user.clients, Commenting code for shorter token expiration time
          refreshToken: user.refresh_token,
          token: user.token,
        })
      );
    }
    return response.data;
  }

  async checkToken() {
    const response = await axios
      .get("https://api.varsanpr.com/api/auth", {
        withCredentials: true,
      })
      .catch(async (error) => {
        if (error.response.status === 401) {
          if (error.config.url == "https://api.varsanpr.com/api/auth/refresh") {
            // Prevent infinite loop if refresh token request fails
            console.log("Refresh token request failed, redirecting to login");
            localStorage.removeItem("user");
            if (window.location.pathname !== "/login") {
              store.dispatch("auth/logout").then(() => {
                router.replace("/login");
              });
            }
            return Promise.reject(error);
          }
          // 401, attempt to refresh token
          if (!this.refreshPromise) {
            this.refreshPromise = refreshToken().then(() => {
              this.refreshPromise = null;
            });
          }

          await this.refreshPromise;

          return axios(error.config);
        }
      });
    if (response.data.user) {
      let user = response.data;
      // let refreshToken = localStorage.getItem("user").refreshToken; Commenting code for shorter token expiration time
      localStorage.setItem(
        "user",
        JSON.stringify({
          permissions: user.permissions,
          ...user.user,
          clients: user.clients,
        })
      );
    }
    return response.data;
  }

  async refreshToken() {
    return axios
      .post(
        `https://api.varsanpr.com/api/auth/refresh`,
        {},
        {
          withCredentials: true,
        }
      )
      .then(() => {
        console.log("Token refreshed successfully");
        return true;
      })
      .catch((err) => {
        console.log("Error refreshing token", err);
        localStorage.removeItem("user");
        if (window.location.pathname !== "/login") {
          store.dispatch("auth/logout").then(() => {
            router.replace("/login");
          });
        }
        return err;
      });
  }

  async logout() {
    return axios
      .post(
        `https://api.varsanpr.com/api/auth`,
        {},
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        window.location.replace(
          window.location.protocol +
            "//" +
            window.location.hostname +
            ":" +
            window.location.port
        );
      });
  }

  getQR() {
    return axios.get("https://api.varsanpr.com/api/auth/2fa", {
      headers: authHeader(),
    });
  }

  verify2fa(otp) {
    return axios.post(
      "https://api.varsanpr.com/api/auth/2fa",
      { otp: otp },
      { headers: authHeader() }
    );
  }
}

export default new AuthService();
